(() => {
  const shopify = window.Shopify;
  const params = new URLSearchParams(location.search);
  if (!/\/products\/theme-build-patrol-car\/?$/.test(location.pathname)
    || shopify?.theme?.id !== 183683449153 || shopify?.theme?.role !== 'main'
    || shopify.designMode || shopify.inspectMode || shopify.previewMode
    || ['preview_theme_id', 'preview_key', 'section_id', 'sections', 'view'].some(key => params.has(key))
    || document.querySelector('#PBarNextFrame, #preview-bar-iframe')
    || document.querySelector('.sb-3d-launch')) return;
  const config = document.querySelector('[data-sb-patrol-car-config]');
  if (!config) return;
  const gallery = document.getElementById(config.dataset.galleryId);
  const media = gallery?.querySelector('.product__media-item .product-media-container');
  if (!media || !window.HTMLDialogElement) return;
  const viewer = new URL(config.dataset.viewerUrl);
  viewer.searchParams.set('embed', '1');
  viewer.searchParams.set('background', '1');
  viewer.searchParams.set('parentOrigin', location.origin);
  const sheet = document.createElement('link');
  sheet.rel = 'stylesheet'; sheet.href = config.dataset.styleUrl; document.head.append(sheet);
  const launch = document.createElement('button');
  launch.type = 'button'; launch.className = 'sb-3d-launch';
  launch.setAttribute('aria-haspopup', 'dialog'); launch.setAttribute('aria-controls', 'sb-patrol-car-dialog');
  launch.innerHTML = '<svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="m12 2 9 5v10l-9 5-9-5V7l9-5Zm0 10 9-5M12 12 3 7m9 5v10M7.5 4.5l9 5"/></svg>Explore in 3D';
  const dialog = document.createElement('dialog');
  dialog.id = 'sb-patrol-car-dialog'; dialog.className = 'sb-3d-dialog'; dialog.setAttribute('aria-labelledby', 'sb-3d-title');
  dialog.innerHTML = '<header class="sb-3d-header"><div><h2 id="sb-3d-title">Explore the Patrol Car</h2><p>Expand the model to see the components inside.</p></div><button class="sb-3d-close" type="button" aria-label="Close 3D viewer" autofocus><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18"/></svg></button></header><div class="sb-3d-frame"></div>';
  document.body.append(dialog);
  const frameHost = dialog.querySelector('.sb-3d-frame');
  let overflow = '', scrollY = 0;
  let frame, failed = false;
  const syncVisibility = () => frame?.contentWindow?.postMessage({type: 'patrol-car-visibility', active: dialog.open && !document.hidden, reset: !dialog.open}, viewer.origin);
  function ensureFrame() {
    if (failed) { frame?.remove(); frame = null; failed = false; }
    if (frame) return;
    frame = document.createElement('iframe');
    frame.title = 'Interactive Patrol Car model'; frame.src = viewer.href;
    frame.referrerPolicy = 'strict-origin-when-cross-origin';
    frame.addEventListener('load', syncVisibility);
    frameHost.append(frame);
  }
  // Main document, eager images, styles and scripts finish before background work.
  // An intentional click can always start immediately, including during page load.
  async function scheduleWarmup() {
    await document.fonts?.ready;
    const warm = () => { if (!document.hidden) ensureFrame(); };
    if ('requestIdleCallback' in window) requestIdleCallback(warm, {timeout: 2000});
    else setTimeout(warm, 200);
  }
  if (document.readyState === 'complete') scheduleWarmup();
  else window.addEventListener('load', scheduleWarmup, {once: true});
  document.addEventListener('visibilitychange', () => {
    syncVisibility();
    if (!document.hidden && document.readyState === 'complete' && !frame) scheduleWarmup();
  });
  launch.addEventListener('click', event => {
    event.preventDefault(); event.stopPropagation();
    overflow = document.documentElement.style.overflow; scrollY = window.scrollY;
    document.documentElement.style.overflow = 'hidden'; dialog.showModal();
    ensureFrame(); syncVisibility();
  });
  dialog.querySelector('.sb-3d-close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => {
    syncVisibility(); document.documentElement.style.overflow = overflow;
    window.scrollTo({top: scrollY, behavior: 'instant'}); launch.focus({preventScroll: true});
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const r = dialog.getBoundingClientRect();
    if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
  });
  window.addEventListener('message', event => {
    const frame = frameHost.querySelector('iframe');
    if (event.origin !== viewer.origin || event.source !== frame?.contentWindow) return;
    if (event.data === 'patrol-car-load-failed') failed = true;
    if (event.data === 'patrol-car-embed-ready') syncVisibility();
    if (event.data === 'patrol-car-close') dialog.close();
  });
  media.classList.add('sb-3d-media');
  media.append(launch);
})();
